module.exports = __webpack_public_path__ + "img/arrow-left.3f6a9cec.svg";